/* Braymont USA: resilient add-on quick-add (v2), including drawer fallback */
(function(){
  if (window.__brmCartAddonsLoaded) return;
  window.__brmCartAddonsLoaded = true;
  const socksProductId = 15268102832203;
  const base = () => { const p = window.Shopify?.routes?.root || "/"; return p.endsWith("/") ? p : p + "/"; };
  const html = value => String(value == null ? "" : value).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat("en-US",{style:"currency",currency:currency||"USD"}).format(Number(cents||0)/100); }
    catch (e) { return "$" + (Number(cents||0)/100).toFixed(2); }
  };
  const getCart = async () => {
    const r = await fetch(base()+"cart.js",{credentials:"same-origin",cache:"no-store",headers:{"Accept":"application/json"}});
    if (!r.ok) throw new Error("Couldn't read your updated bag.");
    return r.json();
  };
  const previewId = () => {
    const p = new URLSearchParams(location.search).get("preview_theme_id") || String(window.Shopify?.theme?.id || "");
    return /^\d+$/.test(String(p)) ? String(p) : "";
  };
  const sectionParams = () => {
    const params = new URLSearchParams({sections:"cart-drawer,cart-icon-bubble"});
    if (previewId()) params.set("preview_theme_id",previewId());
    return params.toString();
  };
  function validSection(sections) {
    if (!sections || typeof sections["cart-drawer"] !== "string" || typeof sections["cart-icon-bubble"] !== "string") return false;
    try {
      const doc = new DOMParser().parseFromString(sections["cart-drawer"],"text/html");
      return !!doc.querySelector("#CartDrawer .cart-item") && !!doc.querySelector("#CartDrawer .drawer__footer");
    } catch(e) { return false; }
  }
  async function loadSections(initial){
    if(validSection(initial)) return initial;
    const requests = [
      base()+"cart?"+sectionParams(),
      base()+"?"+sectionParams()
    ];
    for (const url of requests) {
      try {
        const r = await fetch(url,{credentials:"same-origin",cache:"no-store",headers:{"Accept":"application/json","X-Requested-With":"XMLHttpRequest"}});
        if(!r.ok) continue;
        const sections = await r.json();
        if(validSection(sections)) return sections;
      } catch(err) { console.warn("[Braymont cart] section retry",err); }
    }
    return null;
  }
  function updateIndicators(drawer,cart){
    const count=drawer.querySelector("[data-brm-cart-count]");
    if(count) count.textContent=String((cart.items||[]).filter(x=>Number(x.product_id)!==15271009517643).reduce((n,x)=>n+Number(x.quantity||0),0));
    const price=drawer.querySelector(".brm-checkout-price");
    if(price) price.textContent=money(cart.total_price,cart.currency);
    const normal=drawer.querySelector(".totals__total-value");
    if(normal) normal.textContent=money(cart.total_price,cart.currency);
    const check=drawer.querySelector("#CartDrawer-Checkout");
    if(check) check.disabled=!cart.item_count;
    const head=document.querySelector("#cart-icon-bubble .cart-count-bubble");
    if(head) {
      const visible=head.querySelector("span:not(.visually-hidden)");
      if(visible) visible.textContent=String((cart.items||[]).filter(x=>Number(x.product_id)!==15271009517643).reduce((n,x)=>n+Number(x.quantity||0),0));
      const hidden=head.querySelector("span.visually-hidden");
      if(hidden) hidden.textContent=(cart.items||[]).filter(x=>Number(x.product_id)!==15271009517643).reduce((n,x)=>n+Number(x.quantity||0),0)+" items";
    }
  }
  function updateProgress(drawer,cart){
    let socks=0,other=0;
    let freeSocks=null,pendingSocks=null,freeThermal=null,pendingThermal=null,applied15=false,applied25=false;
    (cart.items||[]).forEach(item=>{
      if(Number(item.product_id)===socksProductId){
        socks+=item.quantity;
        if(Number(item.final_line_price)===0&&Number(item.original_line_price)>0)freeSocks=item;
        else if(item.properties?.["_Braymont Free Gift"])pendingSocks=item;
      }else if(Number(item.product_id)===15271033143371){
        if(item.properties?.["_Braymont Thermal Gift"]){
          if(Number(item.final_line_price)===0&&Number(item.original_line_price)>0)freeThermal=item;
          else pendingThermal=item;
        }
      }else if(Number(item.product_id)!==15271009517643)other+=item.quantity;
    });
    const allDiscountNames=(cart.items||[]).flatMap(it=>it.discounts||[]).map(d=>String(d.title||""))
      .concat((cart.cart_level_discount_applications||[]).map(d=>String(d.title||"")))
      .concat((cart.discount_codes||[]).filter(d=>typeof d==="string"||d.applicable!==false).map(d=>String(typeof d==="string"?d:d.code||""))).join(" | ");
    applied15=/15\s*%\s*OFF|BRM-NOV26-SET15/i.test(allDiscountNames);
    applied25=/25\s*%\s*OFF|BRM-NOV26-SET25/i.test(allDiscountNames);
    const box=drawer.querySelector(".brm-cart-progress");
    if(!box) return;
    const msg=box.querySelector(".brm-cart-progress__message");
    const track=box.querySelector(".brm-cart-progress__track");
    const fill=track?.querySelector("span");
    let percent=34,notice="";
    if(socks && !other) {
      if(socks>=3){percent=100;notice="✓ 15-pair socks offer unlocked + Free Shipping!";}
      else if(socks===2){percent=68;notice="✓ 10-pair socks offer + Free Shipping unlocked! Add one more pack for the 15-pair offer.";}
      else notice="Add one more 5-pair pack for the $14.95 socks offer + Free Shipping.";
    } else if(socks && other) { percent=100; notice="✓ Free Shipping unlocked! Applicable savings depend on each product and are confirmed at checkout."; }
    else if(other>=3) {percent=100;notice=(applied25?"✓ 25% OFF + ":applied15?"✓ 15% OFF + ":"✓ ")+"Free Shipping Unlocked!";}
    else if(other===2){percent=68;notice=(applied25?"✓ 25% OFF + ":applied15?"✓ 15% OFF + ":"✓ ")+"Free Shipping Unlocked!";}
    else notice="Add one more item to unlock 15% OFF + Free Shipping!";
    if(freeSocks&&other>=2)notice="✓ "+(applied15?"15% OFF + ":"")+"Free Shipping + FREE SOCKS GIFT Unlocked!";
    if(freeThermal&&other>=3)notice="✓ "+(applied25?"25% OFF + ":"")+"Free Shipping + FREE THERMAL TIGHTS GIFT Unlocked!";
    if(msg)msg.textContent=notice;
    const giftStatus=drawer.querySelector("[data-brm-socks-cart-gift]");
    if(giftStatus){
      giftStatus.hidden=!(freeSocks||pendingSocks);
      giftStatus.classList.toggle("brm-socks-cart-gift--pending",!freeSocks&&!!pendingSocks);
      const title=giftStatus.querySelector("[data-brm-socks-cart-gift-title]");
      const desc=giftStatus.querySelector("[data-brm-socks-cart-gift-description]");
      if(title)title.textContent=freeSocks?"FREE SOCKS GIFT UNLOCKED":"FREE SOCKS NOT CONFIRMED";
      if(desc)desc.textContent=freeSocks?"5-Pair Winter Socks · One gift per order":"The gift price has not been discounted. Please review before checkout.";
      const orig=giftStatus.querySelector("[data-brm-socks-cart-gift-original]");
      if(orig&&freeSocks)orig.textContent=money(freeSocks.original_line_price,cart.currency);
      const giftPrice=giftStatus.querySelector("[data-brm-socks-cart-gift-price]");
      if(giftPrice&&freeSocks)giftPrice.textContent="FREE";
    }
    const thermalStatus=drawer.querySelector("[data-brm-thermal-cart-gift]");
    if(thermalStatus){
      thermalStatus.hidden=!(freeThermal||pendingThermal);
      thermalStatus.classList.toggle("brm-socks-cart-gift--pending",!freeThermal&&!!pendingThermal);
      const title=thermalStatus.querySelector("[data-brm-thermal-cart-gift-title]");
      const desc=thermalStatus.querySelector("[data-brm-thermal-cart-gift-description]");
      if(title)title.textContent=freeThermal?"FREE THERMAL TIGHTS UNLOCKED":"THERMAL GIFT NOT CONFIRMED";
      if(desc)desc.textContent=freeThermal?"300g Fleece-Lined Thermal Tights · One gift per order":"Please review the gift price before checkout.";
      const orig=thermalStatus.querySelector("[data-brm-thermal-cart-gift-original]");
      if(orig&&freeThermal)orig.textContent=money(freeThermal.original_line_price,cart.currency);
      const price=thermalStatus.querySelector("[data-brm-thermal-cart-gift-price]");
      if(price&&freeThermal)price.textContent="FREE";
    }
    if(fill)fill.style.width=percent+"%";
    if(track)track.setAttribute("aria-valuenow",String(percent));
  }
  let cartFallbackTotals=null;
  function fallbackRow(item,index,currency){
    const isFreeSocks=Number(item.product_id)===socksProductId&&Number(item.final_line_price)===0&&Number(item.original_line_price)>0;
    const isFreeThermal=Number(item.product_id)===15271033143371&&!!item.properties?.["_Braymont Thermal Gift"]&&Number(item.final_line_price)===0&&Number(item.original_line_price)>0;
    const isFreeGift=isFreeSocks||isFreeThermal;
    const giftBadge=isFreeGift?"<span class='brm-gift-line-badge'>"+(isFreeThermal?"FREE THERMAL TIGHTS GIFT":"FREE SOCKS GIFT")+" · "+money(item.original_line_price,currency)+" SAVED</span>":"";
    const title=html(item.product_title || item.title || "Product");
    const share=cartFallbackTotals?.subtotal>0&&cartFallbackTotals.total<cartFallbackTotals.subtotal?Math.floor(Number(item.final_line_price||0)*cartFallbackTotals.total/cartFallbackTotals.subtotal):Number(item.final_line_price||0);
    const original=Number(item.original_line_price||0);
    const isDiscounted=share<original;
    const rowPrice=isDiscounted?"<div class='brm-cart-discount-prices'><s class='brm-cart-discount-old'>"+money(original,currency)+"</s><strong class='brm-cart-discount-new'>"+(isFreeGift?"FREE":money(share,currency))+"</strong><small class='brm-cart-discount-saved'>You save "+money(original-share,currency)+"</small></div>":"<span class='price price--end'>"+money(original,currency)+"</span>";
    const variant=item.variant_title && item.variant_title!=="Default Title" ? "<div class='brm-fallback-variant'>"+html(item.variant_title)+"</div>" : "";
    const url=html(item.url||"#");
    const image=item.image?"<a href='"+url+"' class='cart-item__link'><img class='cart-item__image' src='"+html(item.image)+"' alt='"+title+"' loading='lazy' width='72' height='86'></a>":"";
    const key=html(item.key);
    return "<tr id='CartDrawer-Item-"+(index+1)+"' class='cart-item brm-fallback-item'>"+
      "<td class='cart-item__media'>"+image+"</td>"+
      "<td class='cart-item__details'><a class='cart-item__name' href='"+url+"'>"+title+"</a>"+giftBadge+variant+"</td>"+
      "<td class='cart-item__totals right'>"+rowPrice+"</td>"+
      "<td class='cart-item__quantity'><div class='brm-fallback-controls'>"+
      "<button type='button' data-brm-qty data-key='"+key+"' data-qty='"+Math.max(0,item.quantity-1)+"' aria-label='Decrease quantity'>−</button>"+
      "<span aria-label='Quantity'>"+item.quantity+"</span>"+
      "<button type='button' data-brm-qty data-key='"+key+"' data-qty='"+(item.quantity+1)+"' aria-label='Increase quantity'>+</button>"+
      "<button type='button' data-brm-qty data-key='"+key+"' data-qty='0' aria-label='Remove item'>×</button>"+
      "</div></td></tr>";
  }
  function localRender(drawer,cart,variantId){
    const target=drawer.querySelector("#CartDrawer-CartItems");
    if(!target) throw new Error("Cart items container is not available.");
    cartFallbackTotals={subtotal:Number(cart.items_subtotal_price||0),total:Number(cart.total_price||0)};
    target.innerHTML="<div class='drawer__cart-items-wrapper'><table class='cart-items' role='table'><tbody>"+(cart.items||[]).map((it,i)=>fallbackRow(it,i,cart.currency)).join("")+"</tbody></table></div><p id='CartDrawer-LiveRegionText' class='visually-hidden' role='status'></p><p id='CartDrawer-LineItemStatus' class='visually-hidden' role='status'></p>";
    const presentIds=new Set((cart.items||[]).map(it=>Number(it.product_id)));
    drawer.querySelectorAll(".brm-addon").forEach(card=>{
      const productId=Number(card.getAttribute("data-brm-product-id"));
      if(productId && presentIds.has(productId)) card.remove();
    });
    updateIndicators(drawer,cart);
    updateProgress(drawer,cart);
    drawer.classList.toggle("is-empty",cart.item_count===0);
    drawer.querySelector(".drawer__inner")?.classList.toggle("is-empty",cart.item_count===0);
    drawer.querySelector("cart-drawer-items")?.classList.toggle("is-empty",cart.item_count===0);
    if(!drawer.classList.contains("active"))drawer.open();
  }
  async function renderCart(drawer,cart,variantId,initial){
    const sections=await loadSections(initial);
    if(sections){
      try {
        drawer.classList.remove("is-empty");
        drawer.querySelector(".drawer__inner")?.classList.remove("is-empty");
        drawer.renderContents({id:variantId,sections});
        drawer.classList.remove("is-empty");
        drawer.querySelector("cart-drawer-items")?.classList.remove("is-empty");
        updateIndicators(drawer,cart);
        return;
      }catch(e){console.warn("[Braymont cart] native drawer render failed; using local refresh",e);}
    }
    localRender(drawer,cart,variantId);
  }
  async function changeFallbackQuantity(btn){
    if(btn.disabled)return;
    const qty=Number(btn.dataset.qty),key=btn.dataset.key;
    if(!Number.isInteger(qty)||qty<0||!key)return;
    btn.disabled=true;
    try{
      const r=await fetch(base()+"cart/change.js",{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify({id:key,quantity:qty})});
      if(!r.ok)throw new Error("Couldn't update the quantity.");
      const cart=await getCart();
      const drawer=document.querySelector("cart-drawer");
      if(drawer)await renderCart(drawer,cart,0,null);
    }catch(e){
      const errors=document.querySelector("#CartDrawer-CartErrors");
      if(errors)errors.textContent=e.message||"Unable to update bag.";
      btn.disabled=false;
    }
  }
  document.addEventListener("click",async event=>{
    const qtyButton=event.target.closest("[data-brm-qty]");
    if(qtyButton){await changeFallbackQuantity(qtyButton);return;}
    const expand=event.target.closest("[data-brm-addon-expand]");
    if(expand){
      const card=expand.closest("[data-brm-addon]");
      const options=card?.querySelector(".brm-addon__options");
      if(!options)return;
      const show=options.hidden;
      options.hidden=!show;
      expand.setAttribute("aria-expanded",String(show));
      expand.textContent=show?"− CLOSE":"+ ADD";
      if(show)options.querySelector("select")?.focus();
      return;
    }
    const btn=event.target.closest("[data-brm-addon-add]");
    if(!btn)return;
    const card=btn.closest("[data-brm-addon]");
    const status=card?.querySelector(".brm-addon__status");
    const variantSelect=card?.querySelector("[data-brm-addon-variant]");
    const optionSelects=[...(card?.querySelectorAll("[data-brm-option-index]")||[])];
    const missing=optionSelects.find(select=>!select.value);
    const match=missing ? null : [...(variantSelect?.options||[])].find(option=>
      option.value && optionSelects.every(select=>option.getAttribute("data-brm-option-"+select.dataset.brmOptionIndex)===select.value)
    );
    const variantId=Number(variantSelect?(match?.value||0):btn.dataset.brmAddonId);
    if(!Number.isSafeInteger(variantId)||variantId<=0){
      if(status)status.textContent=missing?"Please select "+(missing.previousElementSibling?.textContent||"all options")+".":"This combination is unavailable. Please choose another.";
      (missing||optionSelects[0])?.focus();
      return;
    }
    const drawer=document.querySelector("cart-drawer");
    if(!drawer||typeof drawer.renderContents!=="function"){
      if(status)status.textContent="The shopping bag is unavailable. Please try again.";return;
    }
    if(btn.disabled)return;
    const old=btn.textContent;
    btn.disabled=true;btn.textContent="ADDING...";
    if(status)status.textContent="";
    let added=false;
    try{
      const body={items:[{id:variantId,quantity:1}],sections:["cart-drawer","cart-icon-bubble"],sections_url:location.pathname||"/"};
      const response=await fetch(base()+"cart/add.js",{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify(body)});
      const result=await response.json().catch(()=>({}));
      if(!response.ok||result.status)throw new Error(result.description||result.message||"Unable to add item.");
      added=true;
      const cart=await getCart();
      await renderCart(drawer,cart,variantId,result.sections);
      if(typeof publish==="function"&&typeof PUB_SUB_EVENTS!=="undefined"){
        try{publish(PUB_SUB_EVENTS.cartUpdate,{source:"cart-items",cartData:cart,variantId:String(variantId)});}catch(e){}
      }
    }catch(e){
      console.error("[Braymont cart] add-on",e);
      if(added){
        try{
          const cart=await getCart();
          localRender(drawer,cart,variantId);
          return;
        }catch(again){console.error("[Braymont cart] fallback failed",again);}
      }
      if(status)status.textContent=added?"Added, but the bag couldn't update. Open your bag to check.":String(e.message||"Please try again.");
    }finally{
      if(btn.isConnected){btn.disabled=false;btn.textContent=old;}
    }
  });
  if(typeof subscribe==="function"&&typeof PUB_SUB_EVENTS!=="undefined"){
    subscribe(PUB_SUB_EVENTS.cartUpdate,async event=>{
      const drawer=document.querySelector("cart-drawer");
      if(!drawer)return;
      if(event?.cartData?.items&&typeof event.cartData.item_count==="number"){updateIndicators(drawer,event.cartData);return;}
      try{updateIndicators(drawer,await getCart());}catch(e){}
    });
  }
})();
